module.exports = __webpack_public_path__ + "static/ultraspeaking-details-4c317ba1634dc6be23ca888b3f2d93cb.jpg";